import { render, staticRenderFns } from "./VerifyDirector.vue?vue&type=template&id=b4fa20a4"
import script from "./VerifyDirector.vue?vue&type=script&lang=js"
export * from "./VerifyDirector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports